// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"dd2a6dc707632d6adb01","303":"00bc5cefcaa5829d4a43","495":"bf0c43a18b712699bd53"}[chunkId] + ".js";
};